import { ReactElement } from 'react';
import useSWR from 'swr';
import { Heading } from '@appsumo/dorado-react';

import { fetchJson } from '~/lib/fetch';
import { USER_CREDITS_URL } from '~/constants/accounts';
import { AccountPageProps } from '~/types/account';
import {
  AccountCoupons,
  AccountCredits,
  AccountGiftCards,
} from '~/components/account/Discounts';

export default function CouponsCreditsPageCompnent(
  props: Readonly<AccountPageProps>,
): ReactElement {
  const { discountData, initialCart } = props ?? {};

  const { data: userDiscountData } = useSWR(USER_CREDITS_URL, fetchJson, {
    fallbackData: discountData,
  });

  return (
    <div>
      <Heading.H1 className="mb-3">Coupons &amp; credits</Heading.H1>
      <AccountCoupons
        discountData={userDiscountData}
        initialCart={initialCart}
      />
      <AccountCredits discountData={userDiscountData} />
      <AccountGiftCards />
    </div>
  );
}
